import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { AttendanceTable } from "../tables/attendance/AttendanceTable";
import { ReportToolbar } from "../reports/ReportToolbar";
import { useReportFilters } from "../reports/useReportFilters";

// Посещаемость: регистрации и заказы по дням, веб и мобильные приложения
export const AttendancePage: FC = () => {
  const filters = useReportFilters();

  const tableProps = { dateFrom: filters.dateFrom, dateTo: filters.dateTo };

  return (
    <>
      <div className="px-[5px]">
        <ReportToolbar
          period={filters.period}
          onPeriodChange={filters.selectPeriod}
          onDateFromChange={filters.handleDateFromChange}
          onDateToChange={filters.handleDateToChange}
        />
      </div>
      <div className="px-[5px]">
        <Routes>
          <Route
            path="/web"
            element={<AttendanceTable source="web" {...tableProps} />}
          />
          <Route
            path="/app"
            element={<AttendanceTable source="app" {...tableProps} />}
          />
          <Route path="/*" element={<AttendanceTable {...tableProps} />} />
        </Routes>
      </div>
    </>
  );
};
